/**
 * Runtime configuration loaded from the backend at startup.
 * Replaces REACT_APP_AZURE_* environment variables.
 */

export interface RuntimeConfig {
  azure_client_id: string;
  azure_tenant_id: string;
  azure_api_scope: string | null; // null = ID token mode (no custom API scope)
}

let _config: RuntimeConfig | null = null;

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (_config) return _config;

  const res = await fetch(`${API_BASE_URL}/config/public`);
  if (!res.ok) {
    throw new Error(`Failed to load runtime config: ${res.status}`);
  }

  const data = await res.json();

  if (!data.azure_client_id || !data.azure_tenant_id) {
    throw new Error(
      'Configuration Azure incomplète. Vérifiez AZURE_CLIENT_ID et AZURE_TENANT_ID dans le .env backend.'
    );
  }

  _config = data as RuntimeConfig;
  return _config;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!_config) {
    throw new Error('Runtime config not loaded. Call loadRuntimeConfig() first.');
  }
  return _config;
}
